
/**
 * src/web/components/kpi-chart-ranking-table.jsx
 * KPIに登録されているメンバーの一覧テーブル（kpi-chart-page のグラフの下に表示されている）
 */

import React from 'react'
import connect, { calcRankingData, calcRankingTotal, calcUserTableData } from '../../connects/kpi-chart-ranking-table'
import Avatar from 'react-toolbox/lib/avatar'
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
} from 'react-toolbox/lib/table'
import DatePicker from './date-picker.jsx'
import { formatNumber, percent } from '../../helpers/format-number'
import _ from 'lodash'
import moment from 'moment'
import kpiChartTableTheme from './themes/kpi-chart-table.css'

const displayFormat = { separate_1000: true }

class KPIChartRankingTable extends React.Component {
  render() {
    const {
      t,
      ui,
      selectUser,
      updateUI,
      selectedKPIs,
      kpis,
      kpiUI,
    } = this.props

    const userData = calcUserTableData(
                        selectedKPIs,
                        kpis,
                        t,
                        kpiUI.aggregationType,
                        moment(kpiUI.tableSelectedDate).format('YYYY-MM-DD'),
                        moment(kpiUI.tableStartDate).format('YYYY-MM-DD'),
                        moment(kpiUI.tableEndDate).format('YYYY-MM-DD')
                      )

    // Set kpi unit for kpi detail table
    const kpi_unit = Object.keys(userData).length > 0 ? userData[Object.keys(userData)[0]].unit : '';

    // Generate kpiData from userData
    const userKPIData = selectedKPIs.reduce((acc, selected_kpi) => {
      const kpiId = selected_kpi.kpi_id;
      
      const kpiTotals = Object.values(userData).reduce((kpiAcc, userItem) => {
        const kpiData = userItem.kpiData[kpiId];
        
        if (kpiData) {
          return {
            actualTotal: kpiAcc.actualTotal + kpiData.totalActual,
            achievementRateTotal: kpiAcc.achievementRateTotal + kpiData.achievementRate,
            kpiLength: kpiAcc.kpiLength + 1
          };
        }
        return kpiAcc;
      }, {
        actualTotal: 0,
        achievementRateTotal: 0,
        kpiLength: 0
      });
    
      acc[kpiId] = kpiTotals;
      return acc;
    }, {});

    // Generate globalKPIData from userKPIData
    let globalTotal = 0;
    let globalAchievementRateTotal = 0;

    _.map(userKPIData, (item, i) => {
      globalTotal += item.actualTotal;
      globalAchievementRateTotal += item.kpiLength > 0 ? item.achievementRateTotal / item.kpiLength : 0;
    });
    const isMultiKPI = selectedKPIs.length > 1 ? true : false

    return (
      <div>
        <Table selectable={false} theme={kpiChartTableTheme}>
          <TableHead >
            <TableCell numeric style={{ textAlign: 'left' }}>{t('label:メンバー')}</TableCell>
            {_.map(selectedKPIs, (selected_kpi, i)=> 
              <React.Fragment key={i}>
                <TableCell tagName="th" numeric>{selected_kpi.label} {t('label:実績')} ({kpi_unit})</TableCell>
                <TableCell tagName="th" numeric>{selected_kpi.label} {t('label:達成率')}</TableCell>
              </React.Fragment>
            )}
            {isMultiKPI && <TableCell numeric>{t('label:合計実績')} ({kpi_unit})</TableCell>}
            {isMultiKPI && <TableCell numeric>{t('label:合計達成率')}</TableCell>}
          </TableHead>

          {_.map(userData, (item, i)=> 
            <TableRow
              key={i}
              user_id={item.user_id}
              style={{cursor: 'pointer'}}
              onClick={() => selectUser(item.user_id, item.name)}>
              <TableCell style={{ whiteSpace: 'nowrap' }}>
                <Avatar image={item.icon_image.thumb_url} />&nbsp;{item.name}
              </TableCell>
              {_.map(selectedKPIs, (selected_kpi, index)=> 
                <React.Fragment key={index}>
                  <TableCell numeric>
                    {item.kpiData[selected_kpi.kpi_id] ? formatNumber(item.kpiData[selected_kpi.kpi_id].totalActual, displayFormat) : '-'}
                  </TableCell>
                  <TableCell numeric>
                    {item.kpiData[selected_kpi.kpi_id] ? percent(item.kpiData[selected_kpi.kpi_id].achievementRate) + ' %' : '-'}
                  </TableCell>
                </React.Fragment>
              )}
              {isMultiKPI &&
              <TableCell numeric>
                {formatNumber(item.userTotalActual, displayFormat)}
              </TableCell>
              }
              {isMultiKPI &&
              <TableCell numeric>
                {percent(item.kpiLength > 0 ? item.userAchievementRate / item.kpiLength : 0)} %
              </TableCell>
              }
            </TableRow>
          )}

          <TableRow className="total">
            <TableCell><strong>{t('label:合計')}</strong></TableCell>
            {_.map(selectedKPIs, (selected_kpi, index)=> 
              <React.Fragment key={index}>
                <TableCell numeric>
                  <strong>
                    {userKPIData[selected_kpi.kpi_id] &&
                      formatNumber(userKPIData[selected_kpi.kpi_id].actualTotal, displayFormat) + ' ' + kpi_unit
                    }
                  </strong>
                </TableCell>
                <TableCell numeric>
                  <strong>
                    {userKPIData[selected_kpi.kpi_id] &&
                      percent(userKPIData[selected_kpi.kpi_id].kpiLength > 0 ? userKPIData[selected_kpi.kpi_id].achievementRateTotal / userKPIData[selected_kpi.kpi_id].kpiLength : 0) + ' %'
                    }
                  </strong>
                </TableCell>
              </React.Fragment>
            )}
            {isMultiKPI &&
            <TableCell numeric>
              <strong>
                {formatNumber(globalTotal, displayFormat)} {kpi_unit}
              </strong>
            </TableCell>
            }
            {isMultiKPI &&
            <TableCell numeric>
              <strong>
                {percent(Object.keys(userKPIData).length > 0 ? globalAchievementRateTotal / Object.keys(userKPIData).length : 0)} %
              </strong>
            </TableCell>
            }
          </TableRow>
        </Table>
      </div>
    )
  }
}

export default connect(KPIChartRankingTable)



// WEBPACK FOOTER //
// ./src/web/components/kpi-chart-ranking-table.jsx